import React, { useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Title from '../../../components/ui/newDesigns/Title';
import TotalValueCard from '../../../components/ui/newDesigns/TotalValueCard';
import PortfolioAccountAccordion from '../../../components/ui/newDesigns/PortfolioAccountAccordion';
import Loader from '../../../components/ui/loader';

import { usePrivateLayout } from '../../../layout/PrivateLayoutContext';

import { getPortfolioAccounts } from '../../../redux/portfolioOverview/portfolioOverview.slice';

const AdvisorClientAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { setBannerChildren } = usePrivateLayout();

  const { selectedClient } = useSelector((state) => state.clients);

  const { portfolioAccounts, loadingPortfolioAccounts, selectedPortfolioName, selectedAccountIds } =
    useSelector((state) => state.portfolioOverview);

  const clientName = selectedClient?.name ?? '';
  const clientIdNr = selectedClient?.id1 ?? '';

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value) || 0);
  };

  const totalValue = useMemo(() => {
    return (portfolioAccounts ?? []).reduce(
      (total, account) => total + Number(account?.accountNav ?? 0),
      0
    );
  }, [portfolioAccounts]);

  useEffect(() => {
    setBannerChildren(
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
        <Title
          title={selectedPortfolioName || 'Portfolio'}
          subtitle={clientName ? `${clientName} - ID: ${clientIdNr}` : `ID: ${clientIdNr}`}
        />

        <TotalValueCard
          total={loadingPortfolioAccounts ? 'R 0.00' : `R ${formatCurrency(totalValue)}`}
        />
      </Box>
    );

    return () => {
      setBannerChildren(null);
    };
  }, [
    setBannerChildren,
    selectedPortfolioName,
    clientName,
    clientIdNr,
    loadingPortfolioAccounts,
    totalValue
  ]);

  useEffect(() => {
    if (!selectedAccountIds?.length) {
      navigate('/advisor/clients', { replace: true });
      return;
    }

    const request = {
      accountIds: selectedAccountIds,
      date: '2026-07-05T00:00:00.00Z'
    };

    dispatch(getPortfolioAccounts(request))
      .unwrap()
      .catch((error) => {
        console.error('AdvisorClientAccount: Portfolio Accounts error:', error);
      });
  }, [dispatch, navigate, selectedAccountIds]);

  return (
    <>
      <Loader loading={loadingPortfolioAccounts} message="Loading portfolio accounts..." />

      <Box
        width="100%"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
        {!loadingPortfolioAccounts && <PortfolioAccountAccordion accounts={portfolioAccounts} />}
      </Box>
    </>
  );
};

export default AdvisorClientAccount;
